import { useContext } from 'react';
import { getLabel } from '../../../../data/labels';
import { TicketPrinterContext } from '../../../printer/TicketPrinterContext';
import { formatDate } from '../../../utils/formatDate';
import { getCheckbetUrl } from '../../../utils/getCheckbetUrl';
import { getConfiguration } from '../../../utils/configuration';
import { getCurrencySymbol } from '../../../utils/getCurrencySymbol';
import { getHiddenTicket } from '../../../utils/getHiddenTicket';
import { getPrintableAmount } from '../../../utils/getPrintableAmount';
import { getTicketStatusDescription } from '../../../utils/getTicketStatusDescription';
import TupleInfo from '../../TupleInfo';
import EventsList from '../EventsList';
import ReloadTicketSection from '../ReloadTicketSection';
import ShareCardDownloader from '../ShareCardDownloader';
import Winnings from '../Winnings';
import { getEnv } from '../../../env';
import { getTicketCategoryLabel } from '../../../utils/getTicketCategorylabel';
import { getStatusBadgeMod } from '../../../utils/getStatusBadgeMod';

function SystemBetsTicket(props) {
    const conf = getConfiguration();
    const currency = getCurrencySymbol(conf.cs.ct);
    const printerContext = useContext(TicketPrinterContext);
    const ticketUrl = getCheckbetUrl(props.ticket.id);

    let descTicket = getLabel('mybets.sistema');
    let ticketStatus = null;
    if (props.infoTicket || conf.dtsch) {
        descTicket = descTicket + ' ' + (props.ticket.psv ? getLabel('retail.protocol.psv') : getLabel('retail.protocol.psqf'));
        ticketStatus = getTicketStatusDescription(props.ticket.status, props.ticket.paidWithCashout);
    }

    return (
        <div className="mybet-container d-flex flex-column | mb_5">

            {conf.ebv2r ? (
                <div className="sc__ticket-header | mb_5_1">
                    <span className={`sc__status-badge ${getStatusBadgeMod(props.ticket.status)}`}>
                        {getTicketCategoryLabel(props.ticket.status)}
                    </span>
                    <span className="sc__ticket-type | mb_5_1_1">
                        {`${descTicket} (${props.ticket.events.length})`.toUpperCase()}
                        {props.ticket.funBonus &&
                            <span className="cg-mybet-funbonus sc__ticket-badge | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                        }
                        {props.ticket.freeBet &&
                            <span className="cg-mybet-funbonus sc__ticket-badge | mb_5_1_2_2">{getLabel('mybets.freebet')}</span>
                        }
                        {ticketStatus &&
                            <span className="cg-mybet-status-label sc__ticket-badge | mb_5_1_2_3">{ticketStatus.toUpperCase()}</span>
                        }
                    </span>
                    <span className="sc__ticket-date">
                        {formatDate(props.ticket.timestamp).formatted}
                    </span>
                </div>
            ) : (
                <div className="d-flex justify-content-space-between align-items-center margine-su-giu bold pointer details-toggle | mb_5_1">
                    <span className="text-big | mb_5_1_1">{descTicket} ({props.ticket.events.length})</span>
                    <span className="margine-sx margin-right-auto | mb_5_1_2">
                        {props.ticket.funBonus &&
                            <span className="cg-mybet-funbonus | mb_5_1_2_1">{getLabel('mybets.funbonus')}</span>
                        }
                        {props.ticket.freeBet &&
                            <span className="cg-mybet-funbonus | mb_5_1_2_2">{getLabel('mybets.freebet')}</span>
                        }
                        {ticketStatus &&
                            <span className="cg-mybet-status-label | mb_5_1_2_3">{ticketStatus.toUpperCase()}</span>
                        }
                    </span>
                </div>
            )}

            <hr className="mb_4" />
            <div className="mybet-events-container | mb_6">
                <EventsList isPsv={props.ticket.psv} events={props.ticket.events} isSystem={true} isCheckbet={props.isCheckbet} />
            </div>
            <div className="light-grey-bg | mb_5_3">
                <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_1">
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.importo')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{getPrintableAmount(props.ticket.amount, conf.cs.m, conf.cs.nd)} {currency}</span>
                    </div>
                    <div className="d-flex flex-column text-small | mb_5_3_1_1">
                        <span className="grey | mb_5_3_1_1_1">{getLabel('mybets.quotatotale')}</span>
                        <span className="text-medium bold | mb_5_3_1_1_2">{getLabel('mybets.nondisponibile')}</span>
                    </div>
                    <Winnings {...props.ticket} />
                </div>
                <hr className="mb_4" />
                {!(window?.appConfig?.SHOP_MODE) && !props.isSnapshot &&
                    <div className="bet-info d-flex justify-content-space-between align-items-center | mb_5_3_2">
                        <div className="d-flex flex-column text-small var-disclaimer | mb_7">
                            <span className="bet-info-buttons-container justified-text text-medium bold | mb_7_1">
                                {!conf.sdt &&
                                    <div className="my-bets-printer | mb_7_1_1" onClick={() => printerContext.printTicket(props.ticket.id, false)}>
                                        <img className="mb_7_1_1_1" src={`${getEnv('PUBLIC_URL')}/assets/images/print.svg`} alt="Print button" />
                                    </div>
                                }
                                <ShareCardDownloader
                                    ticketUrl={ticketUrl}
                                    ticketId={props.ticket.id}
                                    status={props.ticket.status}
                                    isSnapshot={props.isSnapshot}
                                    dateTimestamp={props.ticket.timestamp}
                                    totalOdd={getLabel('mybets.nondisponibile')}
                                    totalAmount={getPrintableAmount(props.ticket.amount, conf.cs.m, conf.cs.nd)}
                                    winPot={getPrintableAmount(props.ticket.potentialWinnings, conf.cs.m, conf.cs.nd)}
                                />
                                <ReloadTicketSection isCheckbet={true} ticket={props.ticket} />
                            </span>
                        </div>
                    </div>
                }
                <hr className="mb_4" />
                <div className="d-flex justify-content-space-between align-items-center margin-top text-small grey pointer tuples-toggle | mb_8">
                    <div className="d-flex justify-content-space-between | mb_8_1_1">
                        <span className="mb_8_1_1_1">{getLabel('mybets.sistema')}</span>&nbsp;
                    </div>
                    <div className="d-flex justify-content-space-between | mb_8_1_1">
                        <span className="mb_18_1_1_1">Ref. {props.obfuscateTicketId ? getHiddenTicket(props.ticket.id) : props.ticket.id}</span>
                        <span className="margin-left-right | mb_18_1_1_2">|</span>
                        <span className="mb_18_1_1_3">{formatDate(props.ticket.timestamp).formatted}</span>
                    </div>
                </div>
            </div>
            <div id="tuples-info" className="light-grey-bg | mb_9">
                <TupleInfo tuples={props.ticket.tuples} ticketId={props.ticket.id} openCheckSystemBets={props.openCheckSystemBets} />
            </div>
        </div>
    );
}

export default SystemBetsTicket;